import { IAutocompleteMatch } from "@directives/_forms/autocomplete/autocomplete.component";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IVehicle } from "@interfaces/IVehicle";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { JourneyService } from "@services/journey.service";
import { MapService } from "@services/map.service";
import { PlotService } from "@services/plot.service";
import { VehicleService } from "@services/vehicle.service";
import * as angular from "angular";
import { ILatLngLiteral, IPolygon, IPolyline } from "@typings/google.maps.angular";
import { CoordsModel } from "../../livemap/model/CoordsModel";
import { IIsochronePosition, IsochroneService } from "../isochrone.service";
import "./findNearest.scss";

interface IComponentBindings {
}

class ComponentController implements angular.IComponentController, IComponentBindings {

    loading = false;

    searchValue: number = 10;
    searchType: "distance" | "duration" = "distance";

    searchCenterPolyline: IPolyline;
    isochronePolygon: IPolygon;
    mapCenter: CoordsModel;
    mapZoom: number;

    vehicles: IVehicle[];
    vehiclesDisplay: IVehicle[];

    veriMap: IVeriMapComponent;

    static $inject = ["$scope", "$q", "driverAssignmentService", "isochroneService"];

    constructor(
        private readonly $scope: angular.IScope,
        private readonly $q: angular.IQService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private readonly isochroneService: IsochroneService) {
    }

    $onInit(): void {
        this.driverAssignmentService.getVehiclesWithDrivers({ includeLatestPlots: true, includePeripheralMappings: true }).then(vehicles => {
            this.vehicles = vehicles;
            this.vehiclesDisplay = vehicles;
        });
    }

    onMapLoaded(veriMap: IVeriMapComponent) {
        this.veriMap = veriMap;
    }

    selectedMatchChange(match: IAutocompleteMatch) {
        if (!match) {
            return;
        }

        this.mapCenter = new CoordsModel(match.location.lat, match.location.lng);
        this.mapZoom = 17;

        this.veriMap.getMap().setZoom(13);
    }

    calculateIsoChrone(): angular.IPromise<any> {

        if (!this.mapCenter || !this.searchType || !this.searchValue) {
            return;
        }

        var defer = this.$q.defer();

        this.loading = true;
        this.isochronePolygon = null;

        var destination = new google.maps.LatLng(this.mapCenter.latitude, this.mapCenter.longitude);

        this.updateCrossLocation(destination.lat(), destination.lng());

        this.isochroneService.compute({
            lat: destination.lat(),
            lng: destination.lng(),
            cycles: 5,
            slices: 25,
            //type: 'duration',
            //value: 5 * 1760, // 60 miles
            type: this.searchType /*'duration'*/,
            value: this.searchType == "duration" ? this.searchValue * 60 : this.searchValue * 1760, //10 * 60, // 30 mins
            mode: google.maps.TravelMode.DRIVING,
            callback: (status: google.maps.DistanceMatrixStatus | string, points: IIsochronePosition[]) => {
                //console.log("Isochrone.callback", status, points);

                if (status != "OK" && status != google.maps.DistanceMatrixStatus.OVER_QUERY_LIMIT) {
                    return;
                }

                var polygon = this.createIsoPolygon(points);
                this.updateVisibleVehicles(polygon);

                this.veriMap.fitMap(points);

                this.loading = false;
                this.$scope.$digest();

                defer.resolve();
            }
        });

        return defer.promise;
    }

    // -------------------

    private createLatLngLiteralPath(points: google.maps.LatLngLiteral[]): ILatLngLiteral[] {
        var path: ILatLngLiteral[] = [];

        points.forEach(p => {
            path.push({
                latitude: p.lat,
                longitude: p.lng
            });
        })

        return path;
    }

    private createIsoPolygon(points: google.maps.LatLngLiteral[]): google.maps.Polygon {

        //var path: ILatLngLiteral[] = [];
        //var googlePath: google.maps.LatLngLiteral[] = [];

        //points.forEach(p => {
        //    path.push({
        //        latitude: p.lat,
        //        longitude: p.lng
        //    });

        //    googlePath.push({
        //        lat: p.lat,
        //        lng: p.lng
        //    });
        //});

        this.isochronePolygon = {
            id: 1,
            path: this.createLatLngLiteralPath(points),
            fill: { color: 'rgba(0,0,0,0.3)' },
            stroke: {
                color: '#ff6e40'/*'red'*/,
                weight: 2
            }
        }

        return new google.maps.Polygon({ paths: points })
    }

    private updateVisibleVehicles(polygon: google.maps.Polygon) {
        this.vehiclesDisplay = [];

        this.vehicles.forEach(vehicle => {
            if (!vehicle.Plot) {
                return;
            }

            var latLng = new google.maps.LatLng(vehicle.Plot.Latitude, vehicle.Plot.Longitude);
            var inside = google.maps.geometry.poly.containsLocation(latLng, polygon);

            if (inside) {
                this.vehiclesDisplay.push(vehicle);
            }
        });
    }

    private updateCrossLocation(lat: number, lng: number) {

        var polylinePath: google.maps.LatLng[] = [];
        var crossSize = 0.001 * this.searchValue;

        polylinePath.push(new google.maps.LatLng(lat, lng));
        polylinePath.push(new google.maps.LatLng(lat + crossSize, lng));
        polylinePath.push(new google.maps.LatLng(lat - crossSize, lng));
        polylinePath.push(new google.maps.LatLng(lat, lng));
        polylinePath.push(new google.maps.LatLng(lat, lng + crossSize));
        polylinePath.push(new google.maps.LatLng(lat, lng - crossSize));

        this.searchCenterPolyline = {
            id: 1,
            path: polylinePath,
            options: {
                stroke: {
                    color: '#ff6e40'/*'red'*/,
                    weight: 2,
                    opacity: 0.75
                }
            }
        };
    }

    //private isPointInPoly(poly, pt) {
    //    var i, j = cornersX.length - 1;
    //    var odd = false;

    //    var pX = cornersX;
    //    var pY = cornersY;

    //    for (i = 0; i < cornersX.length; i++) {
    //        if ((pY[i] < y && pY[j] >= y || pY[j] < y && pY[i] >= y)
    //            && (pX[i] <= x || pX[j] <= x)) {
    //            odd ^= (pX[i] + (y - pY[i]) * (pX[j] - pX[i]) / (pY[j] - pY[i])) < x;
    //        }

    //        j = i;
    //    }

    //    return odd;
    //}
}

export class FindNearestComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
        };

        this.controller = ComponentController;
        this.template = require("./findNearest.html");
    }
}
